// GameLayout.jsx
// Shared page chrome for the main room — reuses the Phase 1 EscapeHeader
// (back button target matches room.php's back("rules1.php")). The room
// scene itself (rendered by RoomScene, inside `children`) is now a
// position:fixed, full-viewport background with no letterbox, so there's
// no separate blurred backdrop layer to fill anymore — GameBackground is
// no longer used here.
import React from 'react';
import EscapeHeader from './EscapeHeader';
import './GameLayout.css';

function GameLayout({ children }) {
  return (
    <div className="escape-game-page">
      <EscapeHeader backTo="/escape-to-inner-peace/rules" />
      <main className="escape-game-main">{children}</main>
    </div>
  );
}

export default GameLayout;
